module.exports = __webpack_public_path__ + "img/intelligent2.4c6201db.png";